import { Badge, BadgeType } from '@shared/badge';

export enum ForecastReconciliationStatus {
  DRAFT = 'draft',
  FINAL = 'final',
  ARCHIVED = 'archived',
}

export const ForecastReconciliationStatusList = {
  draft: 'Draft',
  final: 'Final',
  archived: 'Archived',
};

export const ForecastReconciliationStatusMap: Record<string, Badge<ForecastReconciliationStatus>> = {
  [ForecastReconciliationStatus.DRAFT]: {
    key: ForecastReconciliationStatus.DRAFT,
    value: 'Draft',
    type: BadgeType.DISABLED,
  },
  [ForecastReconciliationStatus.FINAL]: {
    key: ForecastReconciliationStatus.FINAL,
    value: 'Final',
    background: '#dcfce7',
    color: '#16a34a',
  },
  [ForecastReconciliationStatus.ARCHIVED]: {
    key: ForecastReconciliationStatus.ARCHIVED,
    value: 'Archived',
    type: BadgeType.ERROR,
  },
};

export enum ForecastFileStatus {
  DRAFT = 'draft',
  FINAL = 'final',
}

export const ForecastFileStatusList = {
  draft: 'Draft',
  final: 'Final',
};

export const ForecastFileStatusMap: Record<string, Badge<ForecastFileStatus>> = {
  [ForecastFileStatus.DRAFT]: {
    key: ForecastFileStatus.DRAFT,
    value: 'Draft',
    type: BadgeType.DISABLED,
  },
  [ForecastFileStatus.FINAL]: {
    key: ForecastFileStatus.FINAL,
    value: 'Final',
    background: '#dcfce7',
    color: '#16a34a',
  },
};

export enum ForecastFileLabel {
  FORECAST = 'forecast',
  SCHEDULE = 'schedule',
  ORDER = 'order',
  OTHER = 'other',
}

export const ForecastFileLabelList = {
  forecast: 'Forecast',
  schedule: 'Schedule',
  order: 'Order',
  other: 'Other',
};

export const ForecastFileLabelMap: Record<string, Badge<ForecastFileLabel>> = {
  [ForecastFileLabel.FORECAST]: {
    key: ForecastFileLabel.FORECAST,
    value: 'Forecast',
    type: BadgeType.DISABLED,
  },
  [ForecastFileLabel.SCHEDULE]: {
    key: ForecastFileLabel.SCHEDULE,
    value: 'Schedule',
    type: BadgeType.DISABLED,
  },
  [ForecastFileLabel.ORDER]: {
    key: ForecastFileLabel.ORDER,
    value: 'Order',
    type: BadgeType.DISABLED,
  },
  [ForecastFileLabel.OTHER]: {
    key: ForecastFileLabel.OTHER,
    value: 'Other',
    type: BadgeType.DISABLED,
  },
};
